<template>
  <div id="message-panel">
    <div class="notice"></div>
    <div class="message-list"></div>
    <div class="message-sender"></div>
    <a-modal
      centered
      :visible="imgPreviewSrc !== ''"
      @ok="() => (imgPreviewSrc = '')"
      @cancel="() => (imgPreviewSrc = '')"
      width="500"
      :footer="false"
    >
      <a :href="imgPreviewSrc" target="_blank" class="text-center">
        <img :src="imgPreviewSrc" class="large" />
        <div>点击查看原图</div>
      </a>
    </a-modal>
  </div>
</template>

<script>
import userRoleMap from './common/roleMap'
const auth = BJY.auth
const store = BJY.store
const eventEmitter = BJY.eventEmitter
let messageList = null
let notice = null
let messageSender = null
export default {
  data() {
    return {
      imgPreviewSrc: '',
    }
  },
  methods: {},
  created() {
    // 收到新消息时tab栏对应tab给出提示
    const that = this
    eventEmitter.on(eventEmitter.MESSAGE_RECEIVE, function (e, date) {
      var element = $('#btn-message-list')
      if (!element.hasClass('active')) {
        element.addClass('has-new')
      }
    })
    eventEmitter.on(eventEmitter.MESSAGE_SEND_FORBID_ALL_CHANGE, function (e, date) {
      // console.log('e', e, date)
      if (date.forbidAll) {
        that.$message.success('已开启全员禁言')
      } else {
        that.$message.success('已关闭全员禁言')
      }
    })
  },
  mounted() {
    // 公告
    notice = BJY.Notice.create({
      element: $('#message-panel .notice'), // 父容器
      replace: false,
      defaultContent: '暂无公告~', // 默认无公告时显示文本
      maxLength: 140, // 公告文本最大长度
      contentPlaceholder: '请输入公告正文内容', // 公告文本编辑框提示
      linkPlaceholder: '请输入公告跳转链接（可选）', // 公告链接编辑框提示
      linkErrorHint: 'URL 格式错误', // url 错误提示
      canEdit: auth.isTeacher() || auth.isAssistant(),
    })
    // 创建消息列表组件
    messageList = BJY.MessageList.create({
      element: $('#message-panel .message-list'),
      renderEmoji: function (name, url) {
        if (BJY.isAlicloudImage(url)) {
          return (
            '<img ondragstart="return false" src="' +
            (url + '@100w_1e_1l.png') +
            '" srcset="' +
            (url + '@200w_1e_1l.png') +
            ' 2x">'
          )
        }
        return '<img ondragstart="return false" src="' + url + '">'
      },
      renderImage: function (url) {
        if (BJY.isAlicloudImage(url)) {
          return (
            '<img class="message-img" ondragstart="return false" src="' +
            (url + '@100w_1e_1l.png') +
            '" srcset="' +
            (url + '@200w_1e_1l.png') +
            ' 2x">'
          )
        }
        return '<img ondragstart="return false" src="' + url + '">'
      },
      renderUser: function (user, width, height) {
        var imageUrl = ''
        const arr = user.avatar.split('.')
        const fileType = arr[arr.length - 1]
        if (
          fileType === 'png' ||
          fileType === 'jpg' ||
          fileType === 'bmp' ||
          fileType === 'jpeg'
        ) {
          if (user.avatar.includes('https://static.51lss.com')) {
            imageUrl = user.avatar + '?x-image-process=image/resize,w_40,limit_0'
          } else {
            imageUrl = user.avatar
          }
        } else {
          imageUrl = 'https://static.51lss.com/data/img/defaultStudentPhoto.png?x-image-process=image/resize,w_40,limit_0'
        }
        return {
          id: user.id,
          name: user.name,
          number: user.number,
          // 头像需压缩
          avatar: BJY.compressImage({
            url: imageUrl,
            width: width,
            height: height,
          }),
          avatar2x: BJY.compressImage({
            url: imageUrl,
            width: width * 2,
            height: height * 2,
          }),
          // 根据用户类型，配置角色的英文和本地语言
          role: userRoleMap[user.type].en,
          localRole: userRoleMap[user.type].cn,
          type: user.type,
        }
      },
      loadDistance: 0,
    })

    // 创建消息发送组件
    messageSender = BJY.MessageSender.create({
      element: $('#message-panel .message-sender'),
      canSendEmoji: true,
      canSendImage: false,
      multiline: true,
      messageMaxLength: 140,
      placeholder: '请输入...',
      emotionList: {
        emotionPerRow: 6,
        rowPerPage: 4,
      },
      imageUploader: {
        action: '/web/doc/uploadChatFile',
        data: {
          room_id: store.get('class.id'),
          token: store.get('token'),
        },
        fileName: 'Filedata',
      },
    })
    const that = this
    messageList.nextTick(function () {
      $(messageList.$el).on('click', '.bjy-content .message-img', function () {
        var src = $(this).attr('src')
        var splitEle = /\?x-oss-process/.test(src) ? '?x-oss-process' : '@'
        var originSrc = src.split(splitEle)[0]
        that.imgPreviewSrc = originSrc
      })
    })
  },
  beforeDestroy() {
    messageSender && messageSender.destroy()
    messageList && messageList.destroy()
    notice && notice.destroy()
  },
}
</script>

<style lang="scss">
//@import url() 引入公共css类
#message-panel {
  width: 100%;
  height: 100%;

  .notice {
    position: absolute;
    top: 0;
    z-index: 1;
    background: #fff;
    width: 100%;
    border-top: 1px solid #ddd;
  }

  .bjy-message-list {
    bottom: 110px;
    height: unset;
    top: 32px;
  }

  .bjy-message-sender {
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
}
.large {
  max-width: 450px;
  height: auto;
  margin-top: 20px;
}

.bjy-message-list .bjy-scrollable {
  background-color: #fff;
}
</style>
